import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';

const NotFoundPage = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className="notFoundPage">
                <div className="container">
                    <div className="notFoundPage__content">
                        <span>404</span>
                        <h1>{t('not_found.title')}</h1>
                        <p>{t('not_found.text')}</p>
                        <Link to="/" className="btn btn--styleOne">{t('not_found.button')}</Link>
                    </div>
                </div>
            </main>
            <Footer />
        </Fragment>
    );
};

export default NotFoundPage;
